import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import persistedReducer from "./store/rootReducer";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import EpaparRoad from './EpaperRoad';
import registerServiceWorker from './registerServiceWorker';

const composeEnhancers = composeWithDevTools || compose;
const store = composeEnhancers(applyMiddleware(thunk))(createStore)(persistedReducer);
const persistor = persistStore(store);

ReactDOM.render(
  <Provider store={store}>
     <PersistGate loading={null} persistor={persistor}>
        <EpaparRoad />
      </PersistGate>
   </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
registerServiceWorker();
 